import image from './success.png';
import { Image } from './styled';
export function Illustration() {
    return <Image src={image} alt=""/>;
}
